module.exports = __webpack_public_path__ + "assets/img/flic-internet-request-3.55a1e417.png";